import * as React from "react";
import AppBar from "@mui/material/AppBar";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../contexts/Auth/AuthContext";
import Logout from "@mui/icons-material/Logout";
import styled from "styled-components";
import { ReactComponent as LogoA } from "../assets/a-logo.svg";
import packageJs from "../../package.json";

const StyledAppBar = styled(AppBar)`
  background: linear-gradient(90deg, #0b4f6c 0%, #1e958c 55%, #1e88e5 100%);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
`;

const HeaderInner = styled.div`
  width: 100%;
  padding: 10px 24px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 8px;
  }
`;

const LogoArea = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #ffffff;
  gap: 10px;
`;

const LogoTitle = styled.span`
  font-size: 22px;
  font-weight: 600;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 16px;
    white-space: normal;
    text-align: center;
  }
`;

const VersionCode = styled.span`
  font-size: 11px;
  margin-left: 6px;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.18);
`;

const HeaderText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: row-reverse;
  }
`;

const UserArea = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #ffffff;

  @media (max-width: 768px) {
    align-items: center;
  }
`;

const UserName = styled.span`
  font-size: 18px;
  font-weight: 600;
`;

const UnitInfo = styled.span`
  font-size: 11px;
  text-transform: uppercase;
  opacity: 0.9;
`;

const Header = () => {
  const auth = React.useContext(AuthContext);

  const navigate = useNavigate();

  const handleClose = async () => {
    await auth.signout(auth.user.unit);
    navigate("/");
  };

  return (
    <StyledAppBar position="static" sx={{ marginBottom: 0 }}>
      <HeaderInner>
        <LogoArea href="/autentico/home">
          <LogoA width="52" height="44" />
          <LogoTitle>
            Sistema de Gerenciamento Autêntico
            <VersionCode>Versão {packageJs.version}</VersionCode>
          </LogoTitle>
        </LogoArea>
        {auth.user && (
          <HeaderText>
            <UserArea>
              <UserName>{auth.user.name}</UserName>
              <UnitInfo>Unidade {auth.user.unit}</UnitInfo>
            </UserArea>
            <IconButton
              aria-label="logout"
              size="large"
              onClick={handleClose}
              sx={{
                color: "#ffffff",
                backgroundColor: "rgba(255,255,255,0.12)",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.2)",
                },
              }}
            >
              <Logout />
            </IconButton>
          </HeaderText>
        )}
      </HeaderInner>
    </StyledAppBar>
  );
};

export default Header;
